import { collectPrimaryActionCandidates } from '#pplx/frontend/composer-sdk/internal/primary-action/collectPrimaryActionCandidates.js';
import { useMemo } from 'react';
/**
 * Arbitrates the composer's primary button. Picks the highest-priority candidate
 * whose `when` matches the current context and returns its spec; returns `null`
 * when no candidate matches, signalling the host to render the built-in submit
 * (the priority-0 fallback).
 */
export function usePrimaryAction(plugins, context) {
    const candidates = useMemo(() => collectPrimaryActionCandidates(plugins), [plugins]);
    return useMemo(() => {
        const winner = candidates.find((candidate) => candidate.when(context));
        return winner ? winner.action(context) : null;
    }, [candidates, context]);
}
//# sourceMappingURL=usePrimaryAction.js.map